import styled from "styled-components";

export const SimpleContainer = styled.main`
  font-family: "Pretendard";
  button {
    border: none;
  }
  .label {
    text-align: center;
    margin: 100px 0 50px;
    span {
      display: block;
      &:first-child {
        font-size: 48px;
        font-weight: 800;
        margin-bottom: 15px;
      }
    }
    .description {
      color: #666;
      font-size: 20px;
    }
  }
  .autoScrolling {
    position: relative;
    padding: 20px;
    .info {
      z-index: 10;
      background: #000;
      width: 100%;
      max-width: 400px;
      aspect-ratio: 1;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 40px;
      font-weight: 700;
      strong {
        color: #005ee8;
      }
      span {
        color: #fff;
      }
    }
    .item {
      width: 200px;
      height: 100px;
      object-fit: contain;
      padding: 10px;
    }

    .swiper-wrapper {
      transition-timing-function: linear !important;
    }
    .slideContent {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }
  .products {
    max-width: 1440px;
    padding: 0 20px;
    margin: 0 auto 100px;
    .preview {
      position: relative;
    }
    .action {
      width: 60px;
      height: 60px;
      font-size: 16px;
      position: absolute;
      top: 50%;
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid #bdbdbd;
      z-index: 10;
      border-radius: 50%;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.7);
      svg {
        display: block;
        margin: auto;
      }
      &:first-child {
        left: 0;
      }
      &:last-child {
        right: 0;
      }
    }
    .mySwiper {
      height: 300px;
      width: calc(100% - 60px);
      margin: 0 auto;
    }
    .image {
      width: 100%;
      height: 100%;
      border-radius: 20px;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .boxStack {
    background: #000;
    .inner {
      width: 90vw;
      max-width: 1440px;
      padding: 150px 20px;
      margin: 0 auto;
      height: 400vh;
      position: relative;
    }
    .info {
      font-size: 60px;
      color: #fff;
      font-weight: 700;
      position: sticky;
      position: -webkit-sticky;
      top: 150px;
      height: calc(100vh - 350px);
    }
    .boxContainer {
      position: relative;
    }
    .box {
      cursor: pointer;
      position: sticky;
      margin-left: auto;
      width: 26vw;
      height: 26vw;
      padding: 2.5vw;
      margin-bottom: 50px;
      &.box-1 {
        background: #00ffff;
        top: 150px;
      }
      &.box-2 {
        background: #c7ea46;
        top: 200px;
      }
      &.box-3 {
        background: #ff00ff;
        top: 250px;
      }
      &.box-4 {
        background: #0e072e;
        top: 300px;
        color: #fff;
        img {
          width: 50%;
        }
      }
      border-radius: 40px;
      img {
        object-fit: contain;
        width: 80%;
        height: calc(100% - 220px);
        margin-left: auto;
        display: block;
      }
      span {
        display: block;
        font-size: 40px;
        font-weight: 800;
        margin: 40px 0;
      }
      p {
        font-size: 32px;
        white-space: pre-line;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .boxStack {
      .info {
        font-size: 40px;
      }
      .box {
        width: 50vh;
        height: 50vh;
        span {
          font-size: 36px;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .label {
      span:first-child {
        font-size: 40px;
      }
    }
    .autoScrolling .info {
      max-width: 300px;
      font-size: 30px;
    }
    .boxStack .box {
      width: 400px;
      height: 400px;
      img {
        height: calc(100% - 170px);
      }
      span {
        font-size: 32px;
        margin: 30px 0;
      }
      p {
        font-size: 24px;
      }
    }
    .boxStack .info {
      max-width: calc(100% - 400px);
    }
    .products .action {
      width: 50px;
      height: 50px;
    }
  }
  @media screen and (max-width: 767px) {
    margin-bottom: 100px;
    .label {
      margin: 60px auto 30px;
      span:first-child {
        font-size: 36px;
      }
    }
    .products .action {
      width: 40px;
      height: 40px;
    }
    .autoScrolling .info {
      max-width: 200px;
      font-size: 20px;
    }
    .boxStack {
      .inner {
        padding: 60px 20px;
        height: auto;
      }
      .info {
        max-width: 100%;
        position: relative;
        top: 0;
        font-size: 36px;
        height: auto;
        margin-bottom: 36px;
      }
      .box {
        position: relative;
        top: 0;
        width: 100%;
        border-radius: 20px;
        padding: 50px 30px;
        margin-bottom: 20px;
        height: auto;
        &:last-child {
          margin-bottom: 0;
        }
        &.box-1,
        &.box-2,
        &.box-3 {
          top: 0;
        }
        img {
          height: 200px;
          width: 100%;
          margin-left: 0;
          object-fit: contain;
        }
        span {
          margin: 20px 0;
          font-size: 28px;
        }
        p {
          font-size: 20px;
        }
      }
    }
  }
`;

export const NotBanner = styled.div`
  height: 80px;
`;

export const SimpleBannerContainer = styled.div`
  width: 100%;
  height: 100vh;
  .banners {
    width: 100%;
    height: 100%;
    .bannerSlide {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        user-select: none;
      }
      .content {
        width: 100%;
        max-width: 1440px;
        padding: 0 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        color: #fff;
        transform: translate(-50%, -50%);
        p {
          width: 420px;
          font-size: 64px;
          margin-bottom: 50px;
          font-weight: 800;
          word-break: keep-all;
        }
        button {
          background: rgba(0, 0, 0, 0.1);
          font-size: 18px;
          color: #fff;
          width: 360px;
          height: 70px;
          border-radius: 35px;
          padding: 0 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          svg {
            display: block;
            font-size: 24px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    height: 100vh;
    .banners .bannerSlide .content p {
      font-size: 42px;
      width: 70%;
    }
  }
  @media screen and (max-width: 767px) {
    height: 100vh;
    .banners .bannerSlide .content {
      p {
        margin-bottom: 30px;
      }
      button {
        width: 220px;
        height: 54px;
        font-size: 16px;
      }
    }
  }
`;

export const SimpleProductsContainer = styled.div`
  img {
    user-select: none;
  }
  main#contProductsList {
    margin-top: 0;
    font-family: "Pretendard";
    .subTop_bnr_01 {
      display: none;
    }
    h2 {
      text-transform: uppercase;
    }
    .boundary {
      max-width: 1440px;
      width: 100%;
      padding: 70px 20px;
    }
    #secBrdcrmb {
      display: none;
    }
    .font_color_gray_light {
      padding-bottom: 10px;
      font-size: 18px;
      .fa.fa-bars {
        margin-right: 5px;
      }
      strong {
        color: #000;
      }
    }
    .categorys {
      background: #faf8f7;
      .categoryInfo {
        padding: 20px;
        margin-bottom: 0;
        .toggleButton {
          background: #fff;
          padding: 5px;
        }
      }
      ul {
        border-top: 1px solid rgb(226 226 226);
        box-shadow: none;
        color: #9f9f9f;
      }
    }
    #secList {
      .col_3 {
        position: relative;
        height: 400px;
        border: 1px solid #ddd;
        .img {
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            filter: grayscale(50%);
            opacity: 0.5;
            object-fit: cover;
          }
        }
        .img + div {
          position: absolute;
          left: 0;
          top: 50%;
          padding: 0 20px;
          width: 100%;
          p {
            display: block;
            font-size: 28px;
            &:first-child {
              width: 100%;
              margin-bottom: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              white-space: pre-wrap;
              -webkit-box-orient: vertical;
              line-height: normal;
              padding: 0;
            }
            &:last-child {
              font-weight: lighter;
              background: #fff;
              width: 148px;
              text-align: center;
              padding: 8px 0;
            }
          }
        }
        a:hover {
          color: #000;
        }
        &:hover {
          .img {
            background: #000;
            img {
              opacity: 0.7;
              filter: grayscale(0%);
            }
          }
          p {
            transition: 0.3s;
            &:first-child {
              color: #fff;
            }
          }
        }
      }
    }
    ul.pagination {
      li {
        border: none;
        a {
          color: #bfbfbf;
        }
      }
      li.active,
      li:hover {
        background: transparent;
        a {
          color: #333;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    main#contProductsList #secListTop .count,
    main#contProductsList .categorys ul li {
      font-size: 16px;
    }
    main#contProductsList #secList {
      gap: 20px;
      .col_3 {
        width: calc(50% - 10px);
        .img + div p:first-child {
          font-size: 20px;
        }
        .img + div p:last-child {
          font-size: 18px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    main#contProductsList {
      margin-bottom: 100px;
      #secList {
        gap: 50px;
        .col_3 {
          width: 100%;
          .img + div p:first-child {
            font-size: 20px;
          }
          .img + div p:last-child {
            font-size: 18px;
          }
        }
      }
    }
  }
`;

export const SimpleProductsView = styled.div`
  .sub_page {
    margin-top: 0;
  }
  img {
    user-select: none;
  }
  main#contProductsView {
    margin: 0 auto;
    font-family: "Pretendard";
    .boundary {
      max-width: 1440px;
      width: 100%;
      padding: 70px 20px;
    }
    .subTop_bnr_01 {
      display: none;
    }
    .prd_img_wrapper > img {
      width: 100%;
    }
    #secInfo .btns button {
      border-radius: 10px;
      &.btn_blk {
        background: rgb(0, 33, 83);
        border: 1px solid rgb(0, 33, 83);
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 767px) {
    main#contProductsView {
      margin-bottom: 100px;
    }
  }
`;

export const SimplePortfolioContainer = styled.div`
  img {
    user-select: none;
  }
  main#contProductsList {
    margin-top: 0;
    font-family: "Pretendard";
    h2 {
      text-transform: uppercase;
    }
    .subTop_bnr_01 {
      display: none;
    }
    .boundary {
      max-width: 1440px;
      width: 100%;
      padding: 70px 20px;
    }
    #secBrdcrmb {
      display: none;
    }
    #secListTop .list_info {
      padding-bottom: 10px;
      font-size: 18px;
      .fa.fa-bars {
        margin-right: 5px;
      }
      strong {
        color: #000;
      }
    }
    ul.pagination {
      li {
        border: none;
        a {
          color: #bfbfbf;
        }
      }
      li.active,
      li:hover {
        background: transparent;
        a {
          color: #333;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    main#contProductsList {
      margin-bottom: 100px;
    }
  }
`;

export const SimpleCmpnyContainer = styled.div`
  img {
    user-select: none;
  }
  main#contCompany {
    margin: 0;
    h2 {
      text-transform: uppercase;
    }
    .boundary {
      width: 100%;
    }
    .subTop_bnr_01,
    h2,
    #secBrdcrmb {
      display: none;
    }
    h3,
    .company_content,
    .address_btn_wrapper,
    .google_map_sub_wrapper {
      width: 100%;
      font-size: 20px;
    }
    h3 {
      text-align: center;
      font-size: 36px;
    }
    #secMap {
      max-width: 1440px;
      padding: 0 20px;
      margin: auto;
      h3 {
        &::before {
          display: none;
        }
        span {
          padding: 0;
          border: none;
        }
      }
      .addr {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 10px;
        button {
          margin: 0;
          background: #002153;
          color: #fff;
          font-weight: 700;
          padding: 5px 7px;
        }
      }
      .company_address_h1 {
        color: #000;
        background: transparent;
        margin-bottom: 0;
        padding: 80px 0;
      }
    }
    .company_address_h1 {
      /* color: #3878f6; */
      /* background: #e9edf8; */
      margin-bottom: 0;
      padding: 80px 0;
      font-size: 48px;
    }
    #secMsg.company_wrapper {
      /* background: #e9edf8; */
      padding-bottom: 80px;
      .company_content {
        max-width: 1440px;
        padding: 10px 20px;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    main#contCompany {
      h3 {
        font-size: 32px;
      }
      .company_content,
      .address_btn_wrapper,
      .google_map_sub_wrapper {
        font-size: 16px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    main#contCompany {
      margin-bottom: 100px;
      h3 {
        font-size: 26px;
      }
    }
  }
`;

export const SimpleNoticeContainer = styled.div`
  margin-bottom: 100px;
  main#contNoticeList {
    margin-top: 0;
    font-family: "Pretendard";
    .boundary {
      max-width: 1440px;
      width: 100%;
      padding: 70px 20px;
    }
    a:hover {
      color: #333;
    }
    #secBrdcrmb {
      display: none;
    }
    .subTop_bnr {
      display: none;
    }
    #secListTop {
      margin: 20px 0;
      .count {
        font-size: 18px;
        i.fa-bars {
          margin-right: 5px;
        }
        strong {
          color: rgba(192, 165, 165, 1);
        }
      }
    }
    h2 {
      text-transform: uppercase;
    }
    .notices {
      border-top: 1px solid #000;
      li {
        width: 100%;
        font-size: 24px;
        border-bottom: 1px solid #989898;
        padding: 30px 10px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        .noticeCl {
          font-weight: 700;
          width: 120px;
          color: #c4c4c4;
        }
        .noticeSj {
          width: calc(100% - 300px);
          overflow: hidden;
          text-overflow: ellipsis;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .date {
          color: #c4c4c4;
          width: 130px;
        }
      }
    }
    ul.pagination {
      li {
        border: none;
        a {
          color: #bfbfbf;
        }
      }
      li.active,
      li:hover {
        background: transparent;
        a {
          color: #333;
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    article.boundary {
      padding: 50px 20px;
      margin: 0;
    }
  }
  @media screen and (max-width: 1050px) {
    article.boundary {
      margin: 0;
      width: 100%;
    }
  }
  @media screen and (max-width: 767px) {
    main#contNoticeList .notices li {
      font-size: 14px;
      .noticeCl {
        width: 60px;
      }
      .noticeSj {
        width: calc(100% - 160px);
      }
      .date {
        width: 80px;
      }
    }
  }
`;

export const SimpleSearchContaienr = styled.div`
  font-family: "Pretendard";
  img {
    user-select: none;
  }
  main#contSearch {
    margin-top: 0;
    article.boundary {
      max-width: 1440px;
      width: 100%;
      padding: 70px 20px;
      .shop_port_detail_content,
      .shop_port_title,
      #secBrdcrmb {
        width: 100%;
      }
    }
    h2 {
      display: none;
    }
    #secSchbox .sch_bar {
      input[type="text"]:focus {
        border: none !important;
      }
    }
    .subTop_bnr_01 {
      display: none;
    }
    .font_color_red {
      color: #000;
    }
    span.title {
      font-weight: normal;
      font-size: 1.7rem;
    }
  }
`;

export const SimpleCartContaienr = styled.div`
  img {
    user-select: none;
  }
  main#contCart {
    margin-top: 0;
    article.boundary {
      max-width: 1440px;
      width: 100%;
      padding: 70px 20px;
      .shop_port_detail_content,
      .shop_port_title {
        width: 100%;
      }
    }
    #secBrdcrmb,
    .subTop_bnr_01 {
      display: none;
    }
    .products {
      font-size: 16px;
      border: 1px solid #000;
      label {
        display: flex;
        gap: 5px;
        align-items: center;
        input[type="checkbox"] {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          padding: 0;
          width: 0;
          height: 0;
        }
        .checkmark {
          position: relative;
          top: 0;
          left: 0;
          display: inline-block;
          height: 25px;
          width: 25px;
          border: 1px solid #000;
          background-color: transparent;
          transition: all 0.3s ease;
          &:after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg) scale(0);
            opacity: 0;
            width: 10px;
            height: 15px;
            border: solid #fff;
            border-width: 0px 3px 3px 0px;
            transition: 0.3s;
          }
        }
        input[type="checkbox"]:checked ~ .checkmark {
          background: #000;
          border: 1px solid transparent;
          &:after {
            opacity: 1;
            transform: translate(-50%, -65%) rotate(45deg) scale(1);
          }
        }
        &:hover .checkmark {
          background-color: #efefef;
        }
      }
      li {
        width: 100%;
        padding: 20px;
        border-bottom: 1px solid #000;
        &:last-child {
          border-bottom: none;
        }
        &.header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          button {
            background: #333;
            padding: 3px 10px;
            color: #fff;
          }
        }
        &:not(.header) {
          position: relative;
          display: flex;
          align-items: center;
          gap: 10px;
          .image {
            width: 100px;
            height: 100px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .productInfo {
            width: calc(100% - 182px);
            > span {
              display: block;
              margin-bottom: 5px;
            }
            .productName {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: 500;
            }
            .brand {
              font-size: 12px;
              color: #bbb;
            }
            .price {
              font-size: 22px;
              font-weight: 700;
              margin-bottom: 10px;
            }
            .amount {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border: 1px solid #000;
              width: 120px;
              span {
                display: inline-block;
                width: 60px;
                text-align: center;
                font-weight: 700;
              }
              button {
                width: 30px;
                height: 25px;
                border: none;
                background: transparent;
              }
            }
          }
          > button {
            background: transparent;
            color: #000;
          }
        }
      }
    }
    #secTable .tb_footer {
      flex-wrap: wrap;
      gap: 30px 60px;
      font-size: 20px;
      .total {
        font-size: 24px;
        width: 100%;
        text-transform: uppercase;
        font-weight: 900;
      }
      .btn_order {
        background: #002153;
        color: #fff;
        text-shadow: none;
      }
      .price_detail {
        border-right: none;
      }
      .price_sum dd,
      .font_color_red {
        color: #002153;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    main#contCart {
      .subTop_bnr_01 {
        height: 310px;
        font-size: 40px;
      }
      .products {
        font-size: 14px;
        li {
          padding: 15px;
          position: relative;
        }
        label .checkmark {
          width: 20px;
          height: 20px;
          border-radius: 5px;
          ::after {
            width: 8px;
            height: 12px;
          }
        }
        li:not(.header) {
          align-items: flex-start;
          .image {
            width: 70px;
            height: 70px;
            border-radius: 5px;
          }
          .productInfo {
            width: calc(100% - 144px);
            .brand {
              display: none;
            }
            .price {
              font-size: 18px;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    article.boundary {
      margin-bottom: 100px;
    }
    main#contCart {
      #secTable {
        border-top: 1px solid #ababab;

        dd {
          color: #555;
        }
        .tb_footer .price_detail {
          border-bottom: 1px solid #ababab;
        }
      }
      .products li {
        position: relative;
        label .checkmark {
          width: 20px;
          height: 20px;
          ::after {
            width: 8px;
            height: 12px;
            border-width: 0 2px 2px 0;
          }
        }
        &:not(.header) {
          flex-wrap: wrap;
          .image {
            width: 70px;
            height: 70px;
          }
          .productInfo {
            width: 100%;
            .productName {
              color: #555;
            }
            .brand {
              display: none;
            }
            .price {
              font-size: 14px;
              font-weight: 700;
              margin-bottom: 5px;
            }
          }
        }
        > button {
          position: absolute;
          top: 15px;
          right: 15px;
        }
        &:last-child {
          border-bottom: none;
        }
      }
      #secTable {
        border-top: none;
        .tb_footer {
          font-size: 14px;
          .total {
            font-size: 22px;
          }
          .btn_order {
            font-size: 16px;
          }
        }
      }
    }
  }
`;

export const NavButton = styled.div`
  width: 100%;
  padding: 0 20px;
  height: 90px;
  font-size: 30px;
  font-weight: 500;
  margin: 50px auto;
  display: block;
  text-align: center;
  button {
    width: 100%;
    padding: 0 20px;
    height: 100%;
    border-radius: 50px;
    background: #3b8ef6;
    color: #fff;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    max-width: 440px;
  }
  @media screen and (max-width: 767px) {
    max-width: none;
    font-size: 24px;
    height: 70px;
  }
`;

export const SmProductsContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  margin: 0 auto;
  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    li {
      background: #f4f4f4;
      border-radius: 20px;
      padding: 34px;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
      position: relative;
      img {
        display: block;
        margin: 0 auto;
        height: 200px;
        width: 200px;
        object-fit: contain;
      }
      span {
        display: block;
        font-size: 26px;
        font-weight: 800;
        margin-top: 28px;
      }
      &:nth-child(1) {
        width: calc(50% - 10px);
      }
      &:nth-child(2) {
        width: calc(50% - 10px);
      }
      &:nth-child(3) {
        width: calc(60% - 10px);
      }
      &:nth-child(4) {
        width: calc(40% - 10px);
      }
      &::after {
        content: "더 많은 상품 보러가기";
        position: absolute;
        top: 0%;
        left: 0%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        font-weight: 700;
        color: #fff;
        width: 100%;
        height: 100%;
        transition: 0.5s;
        opacity: 0;
        overflow: hidden;
      }
      &:hover::after {
        opacity: 1;
      }
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
    ul {
      li {
        img {
          height: 150px;
          width: 150px;
        }
        &:nth-child(1) {
          width: 100%;
        }
        &:nth-child(2) {
          width: 100%;
        }
        &:nth-child(3) {
          width: 100%;
        }
        &:nth-child(4) {
          width: 100%;
        }
      }
    }
  }
`;
